import React, { useCallback, useReducer, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Divider,
    Typography,
} from '@mui/material';
import { ValidDataService } from '../../../../service/validDataService';
import { isLocalDev } from '../../../../utils/environment';
import useAbortController from '../../../../hooks/useAbortController';
import { useValidInventoryColumns } from '../useValidInventoryColumns';
import EnhancedTable from '../../../enhancedTable/EnhancedTable';

export default function ContactLensSelectDialog({ open, onClose, onSelect}) {
    const [signal, abortRequest] = useAbortController();
    const columns = useValidInventoryColumns('contacts');
    const [selection, setSelection] = useState()
    const [state, updateState] = useReducer((state, params) => {
        return { ...state, ...params };
    }, {
        data: [],
        totalRowCount: 0,
        pageCount: 0,
        filter: '',
        loading: false,
    });

    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        const from = pageSize * pageIndex;
        updateState({ loading: true });
        ValidDataService.getInventoryDataWithLimit(from, pageSize, filters, sortBy, 'contacts', signal).then(result => {
            const { code, data } = result;
            if (code === 0) {
                updateState({
                    data: data.data,
                    totalRowCount: data.count,
                    pageCount: Math.ceil(data.count / pageSize),
                });
            }
            updateState({ loading: false });
        }).catch(error => {
            if (isLocalDev) {
                console.error(error)
            }
            updateState({ loading: false });
        });
    }, []);

    const handleSelect = () => {
        onSelect(selection[0]);
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        abortRequest();
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
            <DialogTitle>Select Contact Lens</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography variant="h4">Contact Lenses</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <EnhancedTable
                        columns={columns}
                        data={state.data}
                        totalRowCount={state.totalRowCount}
                        pageCount={state.pageCount}
                        fetchData={fetchData}
                        loading={state.loading}
                        selectionMode="single"
                        onRowSelected={(row) => setSelection(row)}
                        actions={[]}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSelect} variant='contained'>
                    Select
                </Button>
                <Button color='cancel' variant='outlined' onClick={onClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}